export default __webpack_public_path__ + "static/stop-f2356977166629503472c48c5ed9a389.png";